// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23CTE","option":"styles_option__6YQHx","active":"styles_active__1grzi"};